const SITE_KEYS: Record<number, string> = {
  6318: '6LdZ5CArAAAAAOjy9cYd2xLzabbAEjVB0FLl3yyZ', // BARNOTE
  9722: '6LdZ5CArAAAAAOjy9cYd2xLzabbAEjVB0FLl3yyZ', // CEMEFI
};

const DEFAULT_SITE_KEY = '6Le9v-8eAAAAAPRQnMKKLydeeQnlJe2WRY4oTUJB';

const getSiteKeyReCAPTCHA = (): string => {
  const entityId = Number(process.env.REACT_APP_ID_ENTITY);
  return SITE_KEYS[entityId] || DEFAULT_SITE_KEY;
};

export default getSiteKeyReCAPTCHA;
